import React, { useState } from 'react'
import { User, LogOut, Save, Mail } from 'lucide-react'
import { useApp } from '../context/AppContext'

export default function Profile() {
    const { user, updateUserProfile, signOut } = useApp()
    const [displayName, setDisplayName] = useState(user?.displayName || '')
    const [saving, setSaving] = useState(false)

    const handleSave = async (e) => {
        e.preventDefault()
        setSaving(true)
        try {
            await updateUserProfile(displayName)
        } finally {
            setSaving(false)
        }
    }

    return (
        <div className="max-w-2xl mx-auto space-y-6 animate-fade-in">
            <div>
                <h2 className="text-2xl font-bold text-gray-900">Profile</h2>
                <p className="text-gray-600 mt-1">Manage your personal information</p>
            </div>

            <div className="card p-6 space-y-6">
                <form onSubmit={handleSave} className="space-y-4">
                    {/* Display Name */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Display Name</label>
                        <div className="relative">
                            <User size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                            <input
                                type="text"
                                value={displayName}
                                onChange={(e) => setDisplayName(e.target.value)}
                                className="input pl-10"
                                placeholder="Your Name"
                            />
                        </div>
                    </div>

                    {/* Email (Read-only) */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
                        <div className="relative">
                            <Mail size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                            <input
                                type="email"
                                value={user?.email || ''}
                                readOnly
                                className="input pl-10 bg-gray-50 text-gray-500 cursor-not-allowed"
                            />
                        </div>
                    </div>

                    <div className="flex justify-end pt-2">
                        <button
                            type="submit"
                            disabled={saving}
                            className="btn btn-primary"
                        >
                            <Save size={18} />
                            {saving ? 'Saving...' : 'Save Changes'}
                        </button>
                    </div>
                </form>

                <hr className="border-gray-100" />

                {/* Sign Out Section */}
                <div>
                    <h3 className="font-medium text-red-600 mb-2">Danger Zone</h3>
                    <button
                        onClick={signOut}
                        className="btn btn-danger w-full sm:w-auto"
                    >
                        <LogOut size={18} />
                        Sign Out
                    </button>
                </div>
            </div>
        </div>
    )
}
